export default {
  gutterBottom: {
    marginBottom: '1.5rem'
  },
};
